<div class="ring" [style.width.px]="size" [style.height.px]="size">
    <svg [attr.width]="size" [attr.height]="size" [attr.viewBox]="'0 0 ' + size + ' ' + size">
        <circle class="ring-bg" [attr.cx]="center" [attr.cy]="center" [attr.r]="radius" [attr.stroke-width]="stroke" fill="none" />
        <circle
            class="ring-fg"
            [attr.cx]="center"
            [attr.cy]="center"
            [attr.r]="radius"
            [attr.stroke-width]="stroke"
            fill="none"
            stroke-linecap="round"
            [attr.stroke-dasharray]="circumference"
            [attr.stroke-dashoffset]="dashOffset"
            [attr.transform]="'rotate(-90 ' + center + ' ' + center + ')'"
        />
    </svg>
    <div class="ring-label" [class.ring-label--compact]="compact">
        <span class="ring-percent">{{ percent }}%</span>
        <span class="ring-count" *ngIf="!compact">{{ done }}/{{ total }} Done</span>
    </div>
</div>
